// noinspection JSUnusedLocalSymbols
define([
  "backbone",
  "marionette",
  "messaging/messenger",
  "i18n/i18n",
  "./topicResponseCampaignModalView",
  "modules/header/kbMenu/kbMenuModel",
  "./topicResponseCampaignModel",
], function (
  Backbone,
  Marionette,
  Messenger,
  i18next,
  TopicResponseCampaignModalView,
  KbMenuModel,
) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "topicResponseCampaign";
      this.region = options.region;
    },
    show: function (options) {
      this.conversationNode = options.conversationNode;
      this.responseCampaignsCollection = options.responseCampaignsCollection;
      this.responseTemplate = options.responseTemplate;
      const responseKbCampaignModel = options.kbCampaignModel;
      this.responseKbCampaignModel = responseKbCampaignModel;
      this.selectedCampaignId = responseKbCampaignModel.get("id");
      const allKbCampaignsWithDefault = options.kbCampaignsWithDefault;
      this.kbId = Messenger.reqres.request("active:kb");

      const model = new Backbone.Model({
        responseKbCampaignModel: responseKbCampaignModel,
        allKbCampaignsWithDefault: allKbCampaignsWithDefault,
      });

      this.view = new TopicResponseCampaignModalView.topicResponseCampaignModalView({
        model: model,
      });

      this.view.on("campaign:changed", (selectedCampaignId) => {
        this.selectedCampaignId = selectedCampaignId;
      });

      this.view.on("save:campaign", this._saveCampaign, this);

      this.view.on("discard:change", () => Messenger.vent.trigger("close:modal"));

      this.showRegion(this.view);
    },
    _saveCampaign: function () {
      if (this.responseKbCampaignModel.get("id") === this.selectedCampaignId) {
        // campaign is the same as before, no need to change the model
        Messenger.vent.trigger("close:modal");
      } else {
        const promises = [];
        const respTempIds = [];
        this._walkPath(respTempIds);
        // campaign is different, change the model
        respTempIds.forEach((templateId) => {
          let responseCampaignMapping = this.responseCampaignsCollection.findWhere({
            respTempId: templateId,
          });
          if (!responseCampaignMapping) {
            responseCampaignMapping = this.responseCampaignsCollection.addResponseCampaign({
              campaignId: this.selectedCampaignId,
              respTempId: templateId,
              rootIntentId: Messenger.reqres.request("current:topic:id"),
            });
          } else {
            responseCampaignMapping.set("campaignId", this.selectedCampaignId);
          }
          promises.push(responseCampaignMapping.saveModelPromise());
        });
        Messenger.vent.trigger("show:saving:display");
        Promise.all(promises)
          .catch((e) => {
            console.error("Could not save response campaign", e);
            Messenger.okDialog(e);
          })
          .finally(() => {
            //fire event that the node was selected in order to rerender the response preview
            Messenger.vent.trigger("selected:node", this.conversationNode);
            Messenger.vent.trigger("close:saving:display");
            Messenger.vent.trigger("close:modal");
          });
      }
    },
    _walkPath: function (respTempIds) {
      let parent = this.conversationNode;
      while (parent) {
        const responseTemplate = parent.findResponseTemplate(
          this.responseTemplate.get("touchpointId"),
          this.responseTemplate.get("languageId"),
        );
        if (responseTemplate) {
          respTempIds.push(responseTemplate.get("templateId"));
        }
        if (parent.collection) {
          parent = parent.collection.parentConversation;
        } else {
          break;
        }
      }
    },
  });
});
